import { flatMap } from 'lodash';
import { TemplateId } from 'data/templates/api';
import { ProjectTemplateSpaceTab } from '../types';
import { useProjectTemplateSpaces } from './use-get-all-spaces';

export const useProjectTemplateSpaceTabs = (): AtLeast<
  ProjectTemplateSpaceTab,
  'spaceTabId' | 'spaceTabType' | 'spaceTabTitle'
>[] => {
  const spaces = useProjectTemplateSpaces();
  const spaceTabs = flatMap(
    Object.values(spaces).map((space) => space.spaceTabs),
  );

  return spaceTabs;
};

export const useProjectTemplateSpaceIds = (
  projTemplateId: TemplateId,
): TemplateId[] => {
  const spaces = Object.values(useProjectTemplateSpaces());
  const arrayOfDocIds: TemplateId[] = [];

  spaces.forEach((x) => {
    x.spaceTabs.forEach((y) => {
      arrayOfDocIds.push(y.spaceTabId);
    });
  });

  arrayOfDocIds.push(projTemplateId);

  return arrayOfDocIds;
};
